/**
 * Logto OIDC Callback - Verarbeitet den Auth-Redirect
 */

import { useHandleSignInCallback } from '@/auth/oidc'
import { Loader2, AlertCircle } from 'lucide-react'

const POST_LOGIN_REDIRECT_KEY = 'netzfabriks_post_login_redirect'

export function Callback() {
  const { error } = useHandleSignInCallback(() => {
    // Hard redirect statt React Router navigate
    // Damit wird die ganze App neu geladen und der AuthProvider
    // erkennt den neuen Logto-Authenticated-State
    const redirectTo = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY) || '/'
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
    window.location.replace(redirectTo)
  })

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4 max-w-md px-4">
          <AlertCircle className="h-12 w-12 mx-auto text-destructive" />
          <h2 className="text-xl font-semibold">Anmeldung fehlgeschlagen</h2>
          <p className="text-muted-foreground text-sm break-all">{error.message}</p>
          <button
            onClick={() => { window.location.href = '/login' }}
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            Erneut versuchen
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin mx-auto text-primary" />
        <p className="text-muted-foreground">Anmeldung wird abgeschlossen...</p>
      </div>
    </div>
  )
}

export default Callback
